import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/common';
import { PiezaDesgasteHtmlModel } from '../models/pieza-desgaste-html';

@Injectable({
  providedIn: 'root'
})

export class PiezaDesgasteHtmlService {

  private pathAPI = environment.urlAPI;
  private controller = "CupraPiezaDesgasteHtml/";

  constructor(private http: HttpClient) { }

  public searchData(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public post(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public delete(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + id);
  }

  public get(id: string): Observable<PiezaDesgasteHtmlModel> {
    return this.http.get<PiezaDesgasteHtmlModel>(this.pathAPI + this.controller + id);
  }

  public saveFiles(fileDocument: File): Observable<any> {
    let formData: FormData = new FormData();
    if (fileDocument != undefined) {
      formData.append('fileHtml', fileDocument, fileDocument.name);
    }
    return this.http.post<any>(this.pathAPI + this.controller + 'SaveFiles', formData);
  }

  public getFiles(id: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetFiles/' + id;
    return this.http.get<Blob>(endpoint, requestOptions);
  }
}
